export default "__VITE_ASSET__c7383366__"